export default function interpolate(template: string, params?: Record<string, unknown>) {
  const names = params ? Object.keys(params) : [];
  const values = params ? Object.values(params) : [];
  // eslint-disable-next-line no-new-func
  return new Function(...names, `return \`${template}\`;`)(...values);
}
